"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dnd;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Dnd(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "dnd"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "dnd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "menudotted-fill",
    className: "cls-1",
    d: "M43.5,50a8,8,0,1,1-8-8A8,8,0,0,1,43.5,50Zm-8-40a8,8,0,1,0,8,8A8,8,0,0,0,35.5,10Zm0,64a8,8,0,1,0,8,8A8,8,0,0,0,35.5,74Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "menudotted-fill-2",
    "data-name": "menudotted-fill",
    className: "cls-1",
    d: "M72.5,50a8,8,0,1,1-8-8A8,8,0,0,1,72.5,50Zm-8-40a8,8,0,1,0,8,8A8,8,0,0,0,64.5,10Zm0,64a8,8,0,1,0,8,8A8,8,0,0,0,64.5,74Z"
  }))));
}